import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { ObjectIdSchema } from '../../shared/object-id.schema';
/**
 * Assign Recording Delegate Request Schema
 * POST /api/v2/process-step-assignment/:id/recording-delegate
 * Assignment ID provided as URL parameter
 *
 * Nominates the user who records on an ExternalContact assignee's behalf. The
 * delegate may be an external member — unlike the assignment's own assignee
 * rules, recording for a contact is data entry the process owner delegates
 * rather than work the delegate was invited to do.
 */ export const AssignRecordingDelegateRequestSchema = z.object({
    recordingDelegate: ObjectIdSchema
});
export const AssignRecordingDelegateResponseSchema = z.void();
export const AssignRecordingDelegateErrorSchema = BaseErrorSchema;

//# sourceMappingURL=assign-recording-delegate.schema.js.map